export default __webpack_public_path__ + "static/media/rocket.e9d2933d.png";